import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalTambah extends React.Component {
    render() {
        const { ShowModalDel, CancelHandler, DeleteHandler2, Model } = this.props

        return (
            <div>
                <Modal show={ShowModalDel} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Hapus</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Anda yakin ingin menghapus kategori {Model.NAMA}?</p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Tidak</button>
                        <button class="btn btn-danger" onClick={() => DeleteHandler2()}>Yakin</button>
                         

                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}